<script setup>
import FlexColumn from '@/components/shared/page/FlexColumn.vue'

//Emits and props
defineEmits([
  'click',
])
</script>

<template>
  <FlexColumn
    :class="$style.card"
    v-bind="$attrs"
    hide-empty
    @click="$emit('click', $event)"
  >
    <slot />
  </FlexColumn>
</template>

<style module lang="scss">
.card {
  padding: 1rem;
  border-radius: var(--border-radius-s);
  background-color: var(--bg-page-element);
  border-bottom: 1px solid var(--color-borders);
  &:first-child {
    border-top: 1px solid var(--color-borders);
  }
  gap: 0;
  &:focus {
    background-color: var(--bg-page-body);
  }
  @media (min-width: 1024px) {
    border: 1px solid var(--color-borders);
    &:focus {
      border-color: var(--p-form-field-focus-border-color);
      background-color: var(--bg-page-element);
    }
  }
}
</style>
